function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './SelectField.css';
import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
const reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
const SelectField = _ref => {
  let {
    name,
    value,
    changeEvent,
    blurEvent,
    label,
    id,
    options,
    labelLight,
    fieldError,
    autoComplete = 'off',
    required = false,
    placeholder
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [highLightDrop, setHighLightDrop] = useState(false);
  const clickedDropRef = useRef(false);
  const [dropOpened, setDropOpened] = useState(false);
  function handleChange(el) {
    changeEvent({
      title: {
        jss: {
          value: el.title
        }
      },
      icon: {
        jss: {
          value: el.icon
        }
      },
      currencyId: {
        jss: {
          value: el.value
        }
      },
      value: el.value
    });
    setDropOpened(false);
  }
  function handleBlur(event) {
    blurEvent(event.value);
    clickedDropRef.current = false;
    setHighLightDrop(false);
    setDropOpened(false);
  }
  function handleDropMousedown() {
    clickedDropRef.current = true;
    setDropOpened(!dropOpened);
  }
  function handleDropFocus() {
    if (!clickedDropRef.current) {
      setHighLightDrop(true);
    }
  }
  const handleDropKeyDown = e => {
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  const handleDropTouchstart = e => {
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  const rawCountryItems = options.map((item, index) => {
    return {
      label: /*#__PURE__*/React.createElement("span", {
        className: "select-item"
      }, Object.keys(item.icon.jss.value).length ? /*#__PURE__*/React.createElement("img", {
        alt: item.icon.jss.value.alt,
        className: `select-item__image ${Object.keys(item.icon.jss.value).length ? '' : 'hidden'}`,
        src: item.icon.jss.value.src
      }) : null, /*#__PURE__*/React.createElement("span", {
        className: "select-item__text"
      }, /*#__PURE__*/React.createElement("span", {
        className: "visible-label__title"
      }, item.title.jss.value), /*#__PURE__*/React.createElement("span", {
        className: "visible-label__value"
      }, item.currencyId.jss.value))),
      visibleLabel: /*#__PURE__*/React.createElement("span", {
        className: "visible-label"
      }, /*#__PURE__*/React.createElement("span", {
        className: "visible-label__title"
      }, item.title.jss.value), /*#__PURE__*/React.createElement("span", {
        className: "visible-label__value"
      }, item.currencyId.jss.value)),
      title: item.title.jss.value,
      value: item.currencyId.jss.value,
      icon: Object.keys(item.icon.jss.value).length ? item.icon.jss.value.src : {}
    };
  });
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group lr__form-group-select"
  }, label ? /*#__PURE__*/React.createElement("label", {
    className: `body-small form-label ${labelLight ? 'lr__label-light' : ''}`,
    htmlFor: id
  }, label, required ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : '') : null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-primary lr__dd",
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart
  }, Object.keys(value).length && /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: name,
    id: id,
    options: rawCountryItems,
    defaultValue: value,
    className: `react-custom-select
							${highLightDrop ? 'react-custom-select--outlined' : ''}
							${fieldError ? 'react-custom-select--error' : ''}`,
    onFocus: handleDropFocus,
    onMouseDown: handleDropMousedown,
    onChange: el => handleChange(el),
    onKeyDown: handleDropKeyDown,
    onBlur: handleBlur,
    placeholder: placeholder,
    "aria-label": label,
    "aria-labelledby": label,
    menuIsOpen: dropOpened,
    formatOptionLabel: (option, _ref2) => {
      let {
        context
      } = _ref2;
      return context === 'menu' ? option.visibleLabel : option.label;
    }
  }))), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "c16wv1tv";
const ltrStyles = "l827i3v";
const rtlStyles = "r174673a";
export default SelectField;